var map = {
	"./agenda.png": 356,
	"./atendimento.png": 357,
	"./cadastros.png": 358,
	"./dashboard.png": 359,
	"./distribuicao.png": 360,
	"./fila.png": 361,
	"./leads.png": 362,
	"./relatorios.png": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;